import React from "react"
import style from "./style.module.scss"

export default () => {
  return (
    <div className="op__block mb-5" data-aos="fade-up" data-aos-delay="400">
      <div className="container-fluid">
        <div className={style.list}>
          <h3>Web Development</h3>
          <div className="row">
            <div className="col-lg-4">
              <span className={style.list__title}>Web apps</span>
              <p className="text-muted">
                Deliver high quality single page applcations optimize to your business requirement needs.
              </p>
            </div>
            <div className="col-lg-4">
              <span className={style.list__title}>Systems Design</span>
              <p className="text-muted">
                Industry standard design that helps synchronize your business online.
              </p>
            </div>
            <div className="col-lg-4">
              <span className={style.list__title}>Cloud</span>
              <p className="text-muted">
                Don't bother with hosting, allow us to introduce efficient pay as you use usage of your resources.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
